import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)
const store = new vuex.Store({
  state:{
    userInfo:{}
    },
  mutations:{
    saveUserInfo(state,val){
      state.userInfo=val
    }
  },
  getters:{

  },
  actions:{

  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js